var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.title)?_c('div',{staticClass:"heading"},[_c('h2',{staticClass:"mb-3 mb-lg-5"},[_vm._v(_vm._s(_vm.title))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }